import React from 'react';
import { FormItemCard } from '../../FormItemCard';
import { websiteTypeOptions } from 'common/constants/publicationForm.constants';
import { Radio, Space } from 'antd';
import { titleWebsiteType } from 'common/constants/publicationForm.constants';
import { Text } from '@components/common';

const WebsiteType = ({
  values,
  handleSelectWebsiteType,
  branchStatus,
  currentFocus,
  handleGoBackQuestion,
  handleGoForwardQuestion,
  displayDistinctQuestion,
}) => {
  return (
    <FormItemCard
      name="website_type"
      title={titleWebsiteType[branchStatus]}
      subTitle={'Elige una opción'}
      isCurrent={currentFocus == 'website_type'}
      id={'website_type-container'}
      handleGoBackQuestion={handleGoBackQuestion}
      handleGoForwardQuestion={handleGoForwardQuestion}
      displayDistinctQuestion={displayDistinctQuestion}>
      <Radio.Group
        value={values['website_type']?.name}
        disabled={currentFocus == 'website_type' ? false : true}>
        <Space direction="vertical">
          {websiteTypeOptions?.map((item) => {
            return (
              <Radio
                onChange={() => handleSelectWebsiteType(item)}
                value={item.name}
                key={`mult-opt-${item.id}`}>
                <Text>{item.name}</Text>
              </Radio>
            );
          })}
        </Space>
      </Radio.Group>
    </FormItemCard>
  );
};

export default WebsiteType;
